import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';

/**
 * Share a league code with your mates.
 *
 * Open to **any member**, not just the manager. Getting people in is everyone's
 * job, and the manager can remove anyone they don't want — so gating this would
 * cost invitations and buy no safety.
 *
 * One share sheet, no per-platform buttons: navigator.share covers WhatsApp,
 * Messenger, Teams, Slack and the rest in a single tap on mobile, and there is
 * no useful share URL for several of them anyway. Desktop falls back to copying
 * the message, which is the path there regardless.
 *
 * The message says what will actually happen on the other end, because that
 * changes once the season is under way: before the first game the code puts you
 * straight in, after it the manager has to say yes.
 */
function ShareLeague({ league, className }) {
  const [done, setDone] = useState('');

  const message =
    `Join "${league.name}" on Gaffer Picks.\n`
    + `League code: ${league.leagueCode}\n`
    + (league.joinOpen
      ? "Nothing's kicked off yet, so you'll go straight in."
      : 'The season has started, so the manager will need to wave you through.');

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: league.name, text: message });
        return;
      } catch (err) {
        // Dismissing the sheet rejects. That is not a failure and must not fall
        // through to a silent clipboard write the user never asked for.
        if (err && err.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(message);
      setDone('Copied — paste it to your mates');
    } catch {
      setDone('Copy failed — the code is above');
    }
    setTimeout(() => setDone(''), 2500);
  };

  return (
    <span className={className ? `share-league ${className}` : 'share-league'}>
      <button className="primary-btn" onClick={share}>
        {done ? <Check size={16} /> : <Share2 size={16} />}
        Share
      </button>
      {done && <span className="share-feedback">{done}</span>}
    </span>
  );
}

export default ShareLeague;
